import { useTranslate } from "@refinedev/core";
import dayjs, { Dayjs } from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";

dayjs.extend(localizedFormat);

const T_PREFIX = "media.projects.analytics.activity";

// relativeTime's .fromNow() rounds on elapsed hours rather than calendar-day
// boundaries, which would drift from what a day-bucket actually represents —
// so calendar-day diffing is used here instead (still fine for the per-item
// "2 min ago"-style timestamp, where that rounding is not an issue).
export function getActivityDayGroupLabel(
  date: Dayjs,
  t: ReturnType<typeof useTranslate>
): string {
  const daysAgo = dayjs().startOf("day").diff(date.startOf("day"), "day");

  if (daysAgo === 0) return t(`${T_PREFIX}.today`);
  if (daysAgo === 1) return t(`${T_PREFIX}.yesterday`);
  if (daysAgo < 7) return t(`${T_PREFIX}.daysAgo`, { count: daysAgo });
  if (daysAgo < 28) {
    return t(`${T_PREFIX}.weeksAgo`, { count: Math.floor(daysAgo / 7) });
  }
  return date.format("LL");
}
